exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/template-metrics/edit-template-metrics/edit-template-metrics.component.css
// module id = ../../../../../src/app/template-metrics/edit-template-metrics/edit-template-metrics.component.css
// module chunks = main